import { connect } from 'react-redux';
import {
  tagsUpdatedInSelection,
  cancelAdding,
  doneEditing,
  entryRemove
} from './actions';
import EditPanelModal from 'components/EditPanelModal/index';

const mapStateToProps = ({ scene, data }, ownProps) => {
  const modal = scene.addModal;
  return {
    ...ownProps,
    tagOptions: data.tags,
    tagsSelected: modal.tagsToAdd,
    entries: modal.entriesToAdd,
    loading: modal.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleTagsUpdated: (tags) => { dispatch(tagsUpdatedInSelection(tags)) },
    onCancel: () => { dispatch(cancelAdding()) },
    onDone: (tags, entries) => { dispatch(doneEditing(tags, entries)) },
    onRemove: (url) => { dispatch(entryRemove(url)) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPanelModal)



// WEBPACK FOOTER //
// ./src/scenes/EntriesAddModal/index.js